export const motorInsuranceEntryEndpoints = (builder) => ({
    getMotorInsuranceEntryList: builder.query({
        query: (args = {}) => {
            const {
                pageNumber = 1,
                pageSize = 10,
                searchTerm,
                filterColumn,
                filterValue,
            } = args;

            const params = {
                pageNumber,
                pageSize,
            };

            if (searchTerm) params.searchTerm = searchTerm;
            if (filterColumn) params.filterColumn = filterColumn;
            if (filterValue) params.filterValue = filterValue;

            return {
                url: '/GeneralInsurance/get-motor-insurance-entry-list',
                method: 'POST',
                body: params,
            };
        },
        providesTags: ['MotorInsuranceEntry'],
    }),

    getMotorInsuranceEntryById: builder.query({
        query: (id) => `/GeneralInsurance/get-motor-insurance-entry/${id}`,
        providesTags: (result, error, id) => [{ type: 'MotorInsuranceEntry', id }],
    }),

    getMotorInsurancePremiumInfo: builder.query({
        query: (id) => `/GeneralInsurance/get-motor-insurance-premium-info/${id}`,
        providesTags: (result, error, id) => [{ type: 'MotorInsuranceEntry', id }],
    }),

    saveMotorInsuranceEntry: builder.mutation({
        query: (data) => ({
            url: '/GeneralInsurance/save-motor-insurance-entry',
            method: 'POST',
            body: data,
        }),
        invalidatesTags: ['MotorInsuranceEntry'],
    }),

    deleteMotorInsuranceEntry: builder.mutation({
        query: (id) => ({
            url: `/GeneralInsurance/delete-motor-insurance-entry/${id}`,
            method: 'DELETE',
        }),
        invalidatesTags: ['MotorInsuranceEntry'],
    }),

    bulkDeleteMotorInsuranceEntry: builder.mutation({
        query: (ids) => ({
            url: '/GeneralInsurance/bulk-delete-motor-insurance-entry',
            method: 'DELETE',
            body: { ids },
        }),
        invalidatesTags: ['MotorInsuranceEntry'],
    }),

    checkMotorPolicyNumberExists: builder.query({
        query: ({ policyNumber, insurerId, entryId }) => ({
            url: `/GeneralInsurance/check-motor-policy-exists`,
            method: 'GET',
            params: { policyNumber, insurerId, entryId }
        }),
    }),

    getIDVDepreciationRates: builder.query({
        query: () => ({
            url: '/GeneralInsurance/get-idv-depreciation-rates',
            method: 'GET',
        }),
    }),

    getRTOZone: builder.query({
        query: (rtoCode) => ({
            url: `/GeneralInsurance/get-rto-zone?rtoCode=${rtoCode}`,
            method: 'GET',
        }),
    }),
});
